import type { LeaveCreditBalance } from './leaveTypes';

/**
 * What the employee has LEFT on a leave type — the Credit Balance table's own Balance figure.
 *
 * **A type SHARING its parent's credit answers with the PARENT's balance**: it keeps none of its
 * own, and the parent's is what a leave of this kind draws down. Null where there is nothing to
 * report — the balances have not loaded, or the reader cannot see them.
 *
 * `== null`, never `=== null`: a null property is omitted from the wire and arrives `undefined`.
 */
export function remainingBalance(
  balances: readonly LeaveCreditBalance[] | null,
  leaveTypeId: string,
): number | null {
  const row = balances?.find((b) => b.leaveTypeId === leaveTypeId);
  if (row == null) return null;

  if (row.sharesParentCredit && row.parentLeaveTypeId != null) {
    return balances?.find((b) => b.leaveTypeId === row.parentLeaveTypeId)?.balance ?? null;
  }

  return row.balance ?? null;
}
